import $ from 'jquery'

const init = function() {
    if ($('.shareBtn').length > 0 ) {
        // document.getElementById('shareBtn').onclick = function(e) {
        $('.shareBtn').click(function(e){
            // e.preventDefault
            var dhref = $(this).data('href')
            // console.log(encodeURI(dhref));
            FB.ui({
                method: 'share',
                display: 'popup',
                href: dhref,
            }, function(response){})
        })
    }

    $('#newsletter_submit').on('click', function(e) {
      e.preventDefault();
      window.location.href = '/index.php?area=27&menu=99&page=189&lingua=4&email=' + $('#email').val()
    })

    if ($('input[name="email"]').length > 0) {
      var vars = getUrlVars()
      console.log(vars)
      $('input[name="email"]').val(vars['email'])
    }
}

$(document).ready(init)


function getUrlVars()
{
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}



// WEBPACK FOOTER //
// ./src/themes/pac/index.js